<div
  class="relation-and-sleeve-picker"
  *ngIf="_iconRelations || _relations?.length > 0"
>
  <div
    class="related-picker picker mx-lg-0"
    *ngIf="!_iconRelations && _relations?.length > 0"
  >
    <div class="options">
      <label
        *ngFor="let entry of _relations"
        class="action"
        (click)="filterRelations(entry)"
        [ngClass]="{
          active: entry._active == true
        }"
      >
        {{ entry.group || "Options" }}
      </label>
      <!-- [ngClass]="{
        disabled: entry?.options?.length == 0,
        active: relation.value == entry.label
      }" -->
    </div>
    <ng-container *ngFor="let related of _relations; let last = last">
      <div *ngIf="related._active" class="related flex-wrap d-flex flex-row">
        <a
          class="related-entry"
          [ngClass]="{ active: product.handle == swatch.handle }"
          (mouseenter)="related._hoverTitle = swatch.label"
          (mouseleave)="related._hoverTitle = ''"
          *ngFor="let swatch of related.entries; let index = index"
          [routerLink]="['/products/' + swatch.handle]"
          [style.backgroundColor]="swatch?.image ? 'transparent' : swatch.color"
        >
          <img
            *ngIf="swatch.image"
            height="64"
            width="64"
            sizes="10"
            [ngSrc]="swatch.image"
            [loaderParams]="{ aspect: 1 }"
          />
        </a></div
    ></ng-container>
  </div>
  <div
    class="related-picker picker mx-lg-0"
    *ngFor="let relation of _iconRelations"
  >
    <div class="options">
      <label
        *ngFor="let entry of relation.entries"
        (click)="selectRelation(relation, entry)"
        [ngClass]="{
          disabled: entry?.options?.length == 0,
          active: relation.value == entry.label,
          soldout: entry.soldout
        }"
        class="action"
        >{{ entry.label }}
      </label>
    </div>
    <div class="related d-flex flex-row">
      <a
        *ngFor="let relation of _related; let index = index"
        [routerLink]="['/products/' + relation.handle]"
        class="related-entry entry"
        [ngClass]="{ active: product.handle == relation.handle }"
        ><img
          *ngIf="relation.image"
          height="64"
          width="64"
          [ngSrc]="relation.image"
          [loaderParams]="{ aspect: 1 }"
      /></a>
    </div>
  </div>
  <div
    class="sleeve-picker picker mx-lg-0"
    *ngIf="
      this.product.product_type.toLocaleLowerCase() == 'coffee cup' &&
      _sleeves?.length > 0
    "
  >
    <div class="add-sleeve-text mb-0">
      <label>Add a leather sleeve</label>
    </div>
    <div class="sleeve d-flex flex-row">
      <div
        (click)="clearSleeve()"
        class="sleeve-entry entry none"
        [ngClass]="{ active: !_selectedSleeve }"
      >
        <svg
          height="30"
          width="30"
          viewBox="0 0 30 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <line
            x1="0.853553"
            y1="0.347863"
            x2="28.8536"
            y2="28.3479"
            stroke="black"
          />
        </svg>
      </div>
      <div
        *ngFor="let sleeve of _sleeves; let index = index"
        class="sleeve-entry entry"
        (click)="selectSleeve(sleeve)"
        [ngClass]="{ active: _selectedSleeve?.handle == sleeve.handle }"
      >
        <img
          *ngIf="sleeve.images[1]"
          height="64"
          width="64"
          [ngSrc]="sleeve.images[1]"
          [loaderParams]="{ aspect: 1 }"
        />
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="_options && _options.length > 0">
  <ng-container *ngFor="let option of _options; let last = last">
    <div
      *ngIf="option.values.length > 1"
      class="variant-picker picker"
      [ngClass]="{ 'border-bottom': !last }"
    >
      <ng-container>
        <div class="labels">
          <label class="fw-bold">{{ option.name }}</label>
          <label class="ms-auto">{{ option.value }}</label>
        </div>
        <div class="values">
          <ng-container *ngFor="let value of option.values">
            <button
              *ngIf="value.available"
              (click)="selectOption(option, value.value)"
              class="btn"
              [ngClass]="{
                'btn-dark': option.value === value.value,
                'btn-outline-dark': option.value !== value.value
              }"
            >
              {{ value.label }}
            </button>
            <button
              *ngIf="!value.available"
              disabled
              class="disabled btn btn-outline-dark"
            >
              {{ value.label }}
            </button>
          </ng-container>
        </div>
      </ng-container>
    </div></ng-container
  >
</ng-container>
